import { useEffect, useState } from "react";
import "./users.css";
import httpService from "../../../services/http.service";
import Loader from "../../common/loader";
import "react-toastify/dist/ReactToastify.css";
import ErrorMessage from "../../common/errorMsg";
import SuccessMessage from "../../common/successMsg";
import WarningMessage from "../../common/warnMsg";

const UsersForm = (props) => {
  let [phone, setPhone] = useState("");
  let [username, setUsername] = useState("");
  let [userEmail, setUserEmail] = useState("");

  let [account, setAccount] = useState("");
  let [password, setPassword] = useState("");
  let [type, setType] = useState("");
  let [ID, setID] = useState(null);
  let [loading, setState] = useState(false);
  let [licenseno, setLicenseno] = useState("")
  let [nasSpace, setNasSpace] = useState("")
  let [startDateNas, setStartDateNas] = useState("")
  let [endDateNas, setEndDateNas] = useState("")
  let [startDate, setStartDate] = useState("")
  let [endDate, setEndDate] = useState("")

  useEffect(() => {
    if (props.data) {
      setUsername(
        props.data.customerId
          ? props.data.customerId
          : ""
      );
      setUserEmail(
        props?.data?.email
          ? props?.data?.email
          : ""
      )
      // cloud user
      if ((props.data.type === undefined || props.data.type === "" || props.data.type === "clouduser" || props.data.type === "property_manager") && props.data.customerId !== "Admin") {
        setAccount(props.data.accountNo);
        // console.log(props.data, "asdfghjk")
        setPhone(props.data.mobileNo);
        setLicenseno(props.data?.licenceNo)
        setNasSpace(props.data?.nasSpace)
        setStartDate(props.data?.startDate)
        setEndDate(props.data?.endDate)
        setStartDateNas(props.data?.startDateNas)
        setEndDateNas(props.data?.endDateNas)

        // setEndDate(props.date?.endDate)
      }
      let usertype = "Admin"
      if (props.data.type === "clouduser") {
        usertype = "clouduser"
      }
      else if (props.data.type === "property_manager") {
        usertype = "property_manager"
      }
      setType((props.data.type === undefined || props.data.type === "" || props.data.type === "clouduser" || props.data.type === "property_manager") && props.data.customerId !== "Admin" ? props.data.type === "property_manager" ? "property_manager" : "clouduser" : "admin");
      setID(props.data._id);
    }
  }, [props.data]);

  function hideLoader() {
    setState(false);
  }

  function showLoader() {
    setState(true);
  }

  let handleLicenceValidSubmit = async () => {
    let endtime = new Date(endDate)
    let currentdate = new Date()
    if (endDate == startDate) {
      WarningMessage("End date should be greater than start date !")
      return
    }
    if (endtime <= currentdate) {
      WarningMessage("End date must be greater than start date and current date!")
      return;
    }

    if (licenseno == 0 || !licenseno) {
      WarningMessage("Please Provied a Valid License Number !")
      return;
    }
    if (!startDate || !endDate) {
      WarningMessage("Please Enter correct Licence date !")
      return;
    }

    try {
      let data = {
        id: ID,
        type: type,
        licenceNo: licenseno,
        startDate: startDate,
        endDate: endDate,
      };
      let returnData = await httpService
        .CreateUpdate("savelicence", data)
        .then((res) => res.data)
        .catch((err) => {
          if (err && err.response && err.response.status == 401) {
            ErrorMessage("Session expired, please login again")
          }
          return
        });

      hideLoader();
      if (returnData.ack === "1") {
        SuccessMessage("License has been updated Successfully.")

      } else {
        ErrorMessage(returnData.message)
        return;
      }
      props.loadAllData();
    } catch (e) {

    }
  }

  let handleNASValidSubmit = async () => {
    let endtime = new Date(endDateNas)
    let currentdate = new Date()
    // if(endDateNas == startDateNas){
    //   WarningMessage("End date should be greater than start date !")
    //   return
    // }
    // if(endtime <= currentdate){
    //   WarningMessage("End date must be greater than start date and current date!")
    //   return;
    // }

    if (nasSpace < 0) {
      WarningMessage("Please Provied a Valid Space (in GB) !")
      return;
    }
    // if (!startDateNas || !endDateNas) {
    //   WarningMessage("Please Enter correct date !")
    //   return;
    // }

    try {
      let data = {
        id: ID,
        type: type,
        startDateNas: startDateNas,
        endDateNas: endDateNas,
        nasSpace: nasSpace
      };
      let returnData = await httpService
        .CreateUpdate("savelicence", data)
        .then((res) => res.data)
        .catch((err) => {
          if (err && err.response && err.response.status == 401) {
            ErrorMessage("Session expired, please login again")
          }
          return
        });

      hideLoader();
      if (returnData.ack === "1") {
        SuccessMessage("RCC Cloud Info has been updated Successfully.")

      } else {
        ErrorMessage(returnData.message)
        return;
      }
      props.loadAllData();
    } catch (e) {

    }
  }

  let handleValidSubmit = async () => {
    if (type == "-1" || type == "") {
      WarningMessage("Please Select User Type !")
      return;
    }
    if (username === "") {
      WarningMessage("Please enter User name")
      return;
    }

    if (password === "" && ID === null) {
      WarningMessage("Please enter Password")
      return;
    }
    if (!userEmail) {
      WarningMessage("Please enter Email")
      return;
    }
    if (!validateEmail(userEmail)) {
      // console.log(userEmail);
      WarningMessage("Please Give Valid Email")
      return;
    }
    if (type !== "admin") {
      if (account === "" || account === "-1") {
        WarningMessage("Please Enter the account number")
        return;
      }
      if (phone === "") {
        WarningMessage("Please enter Phone Number")
        return;
      }
      if (phone.toString().length !== 10) {
        WarningMessage("Please enter valid phone number");
        return;
      }
    }
    showLoader();
    let data = {
      id: ID,
      UserName: username.trim(),
      Password: password,
      email: userEmail,
      Phone: phone,
      account: account,
      type: type,
      ActionType: ID ? "Update" : "Add",
    };
    let returnData = await httpService
      .CreateUpdate("SaveUpdateUser", data)
      .then((res) => res.data)
      .catch((err) => {
        if (err && err.response && err.response.status == 401) {
          ErrorMessage("Session expired, please login again")
        }
        return
      });

    if (data.ActionType === "Add") {
      if (returnData.ack === "1") {
        hideLoader();
        SuccessMessage("User has been created successfully.")
        setID(returnData.id)
        hideLoader();
      } else {
        ErrorMessage(returnData.message)
        hideLoader();
        return
      }

    } else {
      hideLoader();
      if (returnData.ack === "1") {
        SuccessMessage("User has been updated Successfully.")

      } else {
        ErrorMessage(returnData)
        return;
      }
    }

    if (props.changeContent) {
      // props.changeContent();
    } else if (props.setformContent) {
      // props.setformContent("list");
    }
    props.loadAllData();
  };

  const cancelClickHandler = () => {
    if (props.changeContent) {
      props.changeContent();
    } else if (props.setformContent) {
      props.setformContent("list");
    }
  };
  const inputValidation = (e) => {
    if (e.target.selectionStart === 0 && e.key === " ") {
      e.preventDefault();
    }
  }

  function validateEmail(email) {
    // console.log(email,"email")
    // Regular expression for a basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Test the email against the regex
    return emailRegex.test(email);
  }

  return (
    <>
      <div className="pad-15">
        <div className="form-boxdiv">
          <div className="form-boxtopline5">
            {props.data ? "Edit User" : "Add User"}
            <button onClick={cancelClickHandler} className="header-btn">User List</button>
          </div>
          <div className="form-boxtopcont user-form">
            {loading ? <Loader /> : null}
            <div className="row">
              {(props?.data?.customerId == "Admin" || props?.data?.type === "property_user") ? "" :
                <div className="col-sm-6">
                  <div className="form-group">
                    <label className="form-check-label">
                      User Type : <i style={{ color: "red" }}>*</i>
                    </label>
                    <select
                      className="form-control"
                      name="role"
                      id="role"
                      value={type}
                      onChange={(e) => props?.data?.type !== "property_manager" &&setType(e.target.value)}
                    >
                      <option value="-1">--Select--</option>
                      <option disabled={props?.data?.type == "property_manager"} value="admin">Admin</option>
                      <option disabled={props?.data?.type == "property_manager"} value="clouduser">Cloud User</option>
                      {/* <option disabled value="property_manager">Property Manager</option> */}
                    </select>
                  </div>
                </div>}
            </div>
            {
              type === "admin" || type === "clouduser" || type === "property_manager" ?
                <div className="row">
                  {/* <div className="row"> */}
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-check-label">
                        User Name : <i style={{ color: "red" }}>*</i>
                      </label>
                      <input
                        className="form-control"
                        type="text"
                        name="user_name"
                        placeholder="Enter Username"
                        value={username}
                        maxLength={30}
                        disabled={props.data && props.data.customerId === "Admin"}
                        onKeyDown={(e) => {
                          inputValidation(e);
                        }}
                        onChange={(e) => {
                          if (e.target.selectionStart === 0 && e.key === " ") {
                            e.preventDefault();
                            return;
                          }
                          if (e.target.value.match(/[^A-Za-z0-9\s]/gi)) {
                            return;
                          }
                          setUsername(e.target.value);
                        }}
                      />
                    </div>
                  </div>
                  {/* </div> */}

                  {/* <div className="row"> */}
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-check-label">
                        Password : <i style={{ color: "red" }}>*</i>
                      </label>
                      <input
                        className="form-control"
                        name="password"
                        label="Password"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value.trim())}
                        placeholder="Enter Password"
                        validate={{
                          required: { value: true, errorMessage: "Required" },
                        }}
                      />
                    </div>
                  </div>
                  {/* </div> */}
                  {/* <div className="row"> */}
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-check-label">
                        Email : <i style={{ color: "red" }}>*</i>
                      </label>
                      <input
                        className="form-control"
                        type="email"
                        name="email"
                        placeholder="Enter User Email"
                        value={userEmail}
                        // disabled={props.data && props.data.customerId === "Admin"}
                        onChange={(e) => {

                          setUserEmail(e.target.value.trim());
                        }}
                        onKeyDown={(e) => {
                          if (e.key === ' ') {
                            e.preventDefault();
                          }
                        }}
                      />
                    </div>
                  </div>
                  {/* </div> */}
                </div> : <></>
            }
            {
              (type === "property_manager" || type === "clouduser") &&
              <div className="row">
                {/* <div className="row"> */}
                <div className="col-sm-6">
                  <div className="form-group">
                    <label className="form-check-label">
                      Account Number : <i style={{ color: "red" }}>*</i>
                    </label>
                    <input
                      className="form-control"
                      name="text"
                      label="account"
                      value={account}
                      placeholder="Enter Account Number"
                      type="text"
                      maxLength={20}
                      // readOnly
                      onChange={(e) => {
                        if (e.target.value.match(/[^A-Za-z0-9\s]/gi)) {
                          return;
                        }
                        // if (e.target.value.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {return;}
                        setAccount(e.target.value.trim());
                      }}
                      validate={{
                        required: { value: true, errorMessage: "Required" },
                      }}
                    />
                  </div>
                </div>
                {/* </div> */}

                {/* <div className="row"> */}
                <div className="col-sm-6">
                  <div className="form-group">
                    <label className="form-check-label">
                      Phone : <i style={{ color: "red" }}>*</i>
                    </label>  
                    <input
                      className="form-control"
                      name="phone"
                      label="Phone"
                      value={phone}
                      placeholder="Enter Phone Number"
                      type="text"
                      maxLength={10}
                      onChange={(e) => {
                        if (e.target.value.match(/[^0-9]/)) {
                          return;
                        }
                        setPhone(e.target.value);
                      }}
                      validate={{
                        required: { value: true, errorMessage: "Required" },
                      }}
                    />
                  </div>
                </div>
                {/* </div> */}
              </div>
            }
          </div>
          <button
            className="btn btn-danger marb-15 marl-15"
            onClick={() => cancelClickHandler()}
          >
            Cancel
          </button>
          <button
            className="btn btn-success marl-15 marb-15"
            onClick={() => handleValidSubmit()}
          >
            {ID ? "Update" : "Save"}
          </button>
        </div>
        <br></br>
        <div style={{ display: "flex", gap: "10px" }}>
          {type == "clouduser" || "property_manager" && ID ? Licence(props, loading, type, licenseno, setLicenseno, startDate, setStartDate, endDate, setEndDate, handleLicenceValidSubmit) : ""}
          {type == "clouduser" || "property_manager" && ID ? Nas(props, loading, type, nasSpace, setNasSpace, startDateNas, setStartDateNas, endDateNas, setEndDateNas, handleNASValidSubmit) : ""}
        </div>
        <br></br>
      </div>
      {/* <ToastContainer /> */}
    </>
  );
};

export default UsersForm;

function Licence(props, loading, type, licenseno, setLicenseno, startDate, setStartDate, endDate, setEndDate, handleValidSubmit) {

  let handleStartDateChange = (e) => {
    const selectedStartDate = e.target.value;
    setStartDate(selectedStartDate);

    // Ensure end date is not before the start date
    if (selectedStartDate > endDate) {
      setEndDate(selectedStartDate);
    }
  };

  let handleEndDateChange = (e) => {
    const selectedEndDate = e.target.value;

    // Ensure end date is not before the start date
    if (selectedEndDate == startDate) {
      WarningMessage("Start Date and End Date Can't be same !")
    }
    if (selectedEndDate >= startDate) {
      setEndDate(selectedEndDate);
    }
  };

  return <div className="form-boxdiv">
    <div className="form-boxtopline5">
      Licence Info
    </div>
    <div className="form-boxtopcont user-form">
      {loading ? <Loader /> : null}

      {type === "clouduser" || "property_manager" ?
        <div className="row">
          <div className="row">
            <div className="col-sm-6">
              <div className="form-group">
                <label className="form-check-label">
                  Total Number Of Property : <i style={{ color: "red" }}>*</i>
                </label>
                <input
                  className="form-control"
                  name="text"
                  label="licenceno"
                  value={licenseno}
                  placeholder="No of Property"
                  type="number"
                  // readOnly
                  onChange={(e) => {
                    if (e.target.value.match(/[^0-9]/)) {
                      return;
                    }
                    setLicenseno(e.target.value);
                  }}
                  validate={{
                    required: { value: true, errorMessage: "Required" },
                  }} />
              </div>
            </div>
          </div>

          <div className="row" >
            <div className="col-sm-5 me-3">
              <div className="form-group">
                <label className="form-check-label">
                  Start Date : <i style={{ color: "red" }}>*</i>
                </label>
                <input
                  className="form-control"
                  name="Date"
                  label="startdate"
                  value={startDate}
                  placeholder="Enter Start Date"
                  type="date"
                  // readOnly
                  onChange={(e) => {
                    handleStartDateChange(e);
                  }}
                  validate={{
                    required: { value: true, errorMessage: "Required" },
                  }} />
              </div>
            </div>
            <div className="col-sm-5">
              <div className="form-group">
                <label className="form-check-label">
                  End Date : <i style={{ color: "red" }}>*</i>
                </label>
                <input
                  className="form-control"
                  name="Date"
                  label="endtdate"
                  value={endDate}
                  placeholder="Enter End Date"
                  // readOnly
                  type="date"
                  onChange={(e) => {
                    handleEndDateChange(e);
                  }}
                  validate={{
                    required: { value: true, errorMessage: "Required" },
                  }} />
              </div>
            </div>
          </div>
        </div> : ""}
    </div>
    <button
      className="btn btn-success marl-15 marb-15"
      onClick={() => handleValidSubmit()}
    >
      Save Licence
    </button>
  </div>;
}


function Nas(props, loading, type, nasSpace, setNasSpace, startDate, setStartDate, endDate, setEndDate, handleNASValidSubmit) {

  let handleStartDateChange = (e) => {
    const selectedStartDate = e.target.value;
    setStartDate(selectedStartDate);

    if (selectedStartDate > endDate) {
      setEndDate(selectedStartDate);
    }
  };

  let handleEndDateChange = (e) => {
    const selectedEndDate = e.target.value;

    if (selectedEndDate == startDate) {
      WarningMessage("Start Date and End Date Can't be same !")
    }
    if (selectedEndDate >= startDate) {
      setEndDate(selectedEndDate);
    }
  };

  return <div className="form-boxdiv">
    <div className="form-boxtopline5">
      RCC Cloud Storage Info
    </div>
    <div className="form-boxtopcont user-form">
      {loading ? <Loader /> : null}
      {type === "clouduser" || "property_manager" ?
        <div className="row">
          <div className="row">
            <div className="col-sm-6">
              <div className="form-group">
                <label className="form-check-label">
                  Allocate Storage in RCC Cloud (in <b>GB</b>): <i style={{ color: "red" }}>*</i>
                </label>
                <input
                  className="form-control"
                  name="text"
                  label="nas_space"
                  value={nasSpace}
                  placeholder="Storage Space on RCC Cloud in GB"
                  type="number"
                  onChange={(e) => {
                    if (e.target.value.match(/[^0-9]/)) {
                      return;
                    }
                    setNasSpace(e.target.value);
                  }}
                  validate={{
                    required: { value: true, errorMessage: "Required" },
                  }} />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-5 me-3">
              <div className="form-group">
                <label className="form-check-label">
                  Start Date : <i style={{ color: "red" }}>*</i>
                </label>
                <input
                  className="form-control"
                  name="Date"
                  label="startdate"
                  value={startDate}
                  placeholder="Enter Start Date"
                  type="date"
                  onChange={(e) => {
                    handleStartDateChange(e);
                  }}
                  // readOnly
                  validate={{
                    required: { value: true, errorMessage: "Required" },
                  }} />
              </div>
            </div>
            <div className="col-sm-5">
              <div className="form-group">
                <label className="form-check-label">
                  End Date : <i style={{ color: "red" }}>*</i>
                </label>
                <input
                  className="form-control"
                  name="Date"
                  label="endtdate"
                  value={endDate}
                  placeholder="Enter End Date"
                  type="date"
                  // readOnly
                  onChange={(e) => {
                    handleEndDateChange(e);
                  }}
                  validate={{
                    required: { value: true, errorMessage: "Required" },
                  }} />
              </div>
            </div>
          </div>
        </div> : ""}
    </div>
    <button
      className="btn btn-success marl-15 marb-15"
      onClick={() => handleNASValidSubmit()}
    >
      Save RCC Cloud Storage Info
    </button>
  </div>;
}